import axiosInstance from './axiosInstance';

export const getMyReferrals        = () => axiosInstance.get('/users/my-referrals');
export const getLevelUsers         = () => axiosInstance.get('/users/level-users');
export const getPerformanceStatus  = () => axiosInstance.get('/users/performance-status');
export const getGenerationStatus   = () => axiosInstance.get('/users/generation-status');
export const getMyRankHistory      = () => axiosInstance.get('/performance/my-ranks');
